import { useState } from 'react';
import { LineChart, Line, ResponsiveContainer, Text } from 'recharts';

import { MetricCardStyledComponent } from 'app/components/StyledComponents/index';

import {
  dataGridTypeEnum,
  metricTypeEnum,
  renderComponentEnum,
  metricIconEnum,
} from 'app/pages/SalesDemoPage/data/type';
import { mockGraphData } from 'app/pages/SalesDemoPage/data/salesDemoMockData';
import { MetricComponent } from '../../../sharedComponents/MetricComponent';

import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type NurturingMetricsComponentProps = {
  metrics;
  onClickMetrics;
  selectedMetric;
  selectedBox;
  setSelectedBox;
};

const metricColor = {
  'Prospects Under Nurturing': '#F0CC38',
  'Target Buyer Profiles': '#FA6845',
  'Engagement Rate': '#A143E3',
  'Unsubscribe Rate': '#3DC2FA',
  'Infuenced Dormant Lead Contacted': '#46F03B',
  'Infuenced Sales': '#3B60F0',
};

export const NurturingMetricsComponent = ({
  metrics,
  onClickMetrics,
  selectedMetric,
  selectedBox,
  setSelectedBox
}: NurturingMetricsComponentProps) => {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;


  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <Grid container spacing={3}>
        {metrics.map(
          (_, index) => (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={3}
              key={`${index}_parent_grid`}
            >
              {/* <MetricCardStyledComponent
                cardSelection={
                  metrics[index * 2]?.type === selectedMetric
                    ? 'topCard'
                    : metrics[index * 2 + 1]?.type === selectedMetric
                    ? 'bottomCard'
                    : ''
                }
                sx={{
                  // padding: '16px',
                  // height: '100%'
                }}
              > */}
                {/* <CardContent> */}
                {metrics[index].valid && <MetricComponent
                  metric={metrics[index]}
                  selectedMetric={selectedMetric}
                  onClickMetrics={onClickMetrics}
                  metricColor={metricColor[metrics[index * 2]?.metric_name]}
                  index={index}
                  metricsLength={Math.ceil(metrics.length / 2)}
                  selectedBox={selectedBox}
                  setSelectedBox={setSelectedBox}
                />}

                {/* Divider */}
                {/* <Box
                  sx={{
                    height: '1px',
                    backgroundColor: '#E0E0E0',
                    // marginTop: 1,
                    // marginBottom: 1,
                    margin: 1,
                    display:
                      metrics.length % 2 !== 0
                        ? index === Math.ceil(metrics.length / 2) - 1
                          ? 'none'
                          : ''
                        : '',
                  }}
                /> */}

                {/* <MetricComponent
                  metric={metrics[index * 2 + 1]}
                  selectedMetric={selectedMetric}
                  onClickMetrics={onClickMetrics}
                  metricColor={metricColor[metrics[index * 2 + 1]?.metric_name]}
                  index={index}
                  metricsLength={Math.ceil(metrics.length / 2)}
                  selectedBox={selectedBox}
                  setSelectedBox={setSelectedBox}
                /> */}
                {/* </CardContent> */}
              {/* </MetricCardStyledComponent> */}
            </Grid>
          ),
        )}
      </Grid>
    </Box>
  );
};
